import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@elaniintc/goes-design-system";
import { useCorrectionForm } from "../context";

interface FormCorrectionApproveModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onApprove: () => void;
  isLoading: boolean;
  applicantName: string;
  formName: string;
}

export const FormCorrectionApproveModal = ({
  isOpen,
  onOpenChange,
  onApprove,
  isLoading,
  applicantName,
  formName,
}: FormCorrectionApproveModalProps) => {
  const { groupCorrectionInCurrentCycle } = useCorrectionForm();
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-156 gap-6">
        <DialogHeader className="space-y-3">
          <DialogTitle className="text-3xl font-semibold text-heading text-center">
            Aprobar comentarios
          </DialogTitle>
          <DialogDescription className="text-base text-body leading-6 text-center">
            {`¿Estás seguro de que deseas aprobar comentarios realizados por `}
            <span className="text-action-loud font-semibold">
              {(() => {
                const creatorFromComments =
                  groupCorrectionInCurrentCycle?.comments?.[0]?.creator;
                const creator =
                  creatorFromComments || groupCorrectionInCurrentCycle?.creator;

                const fullName =
                  creator && typeof creator === "object" && "name" in creator
                    ? `${creator?.name || ""} ${creator?.last_name || ""}`?.trim()
                    : "nombre de técnico";

                return fullName;
              })()}
            </span>
            {`? Estos comentarios serán enviados a `}
            <span className="text-action-loud font-semibold">
              {applicantName || "nombre de usuario"}
            </span>
            {` en la solicitud `}
            <span className="text-action-loud font-semibold">
              {formName || "nombre de solicitud"}
            </span>
            {`.`}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-row gap-3 sm:flex-row pt-2">
          <Button
            variant="quiet"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
            className="flex-1"
          >
            Cancelar
          </Button>
          <Button
            variant="default"
            onClick={onApprove}
            disabled={isLoading}
            className="flex-1"
          >
            {isLoading ? "Aprobando..." : "Aprobar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
